export const getCategories = (payload?: any) => ({
    type: "@saga/GET_CATEGORIES",
    payload
});

